import {useCallback} from "react";
import {useFieldArray, useFormContext} from "react-hook-form";
import {FiPlus} from "react-icons/fi";

import Button from "@/components/button/Button.tsx";
import {Card} from "@/components/card/Card.tsx";
import {Divider} from "@/components/divider/Divider.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {MaintenanceScheduleFormData} from "@/pages/maintenance/maintenance-create/CreateEditMaintenanceScheduleForm.types.ts";
import {MaintenanceInfoBlock} from "@/pages/maintenance/maintenance-create/tabs/notifications/MaintenanceInfoBlock.tsx";
import {DEFAULT_NOTIFICATION_ROW} from "@/pages/maintenance/maintenance-create/tabs/notifications/MaintenanceScheduleNotificationsTab.form.ts";

import {NotificationRow} from "./NotificationRow.tsx";

import styles from "./MaintenanceScheduleNotificationsTab.module.scss";

export const MaintenanceScheduleNotificationsTab = () => {
  const {control, trigger} = useFormContext<MaintenanceScheduleFormData>();
  const {fields, append, remove} = useFieldArray({control, name: "notifications"});

  const handleAddAnother = useCallback(() => {
    append(DEFAULT_NOTIFICATION_ROW);
  }, [append]);

  return (
    <div className={"d-flex flex-column gap-4"}>
      <div className="pulseTextH3Bold">Schedule Reminders</div>
      <div className="pulseTextBody">Send reminders to contacts prior to a Maintenance schedule starting.</div>

      <div className={styles.formWidth}>
        <MaintenanceInfoBlock />

        <Card className={"d-flex flex-column gap-3 mt-4"} variant="default">
          <div className={styles.notificationGrid} onBlur={() => trigger("notifications")}>
            <span className={"pulseTextBodySmallBold text-nowrap"} style={{gridColumn: "1 / 3"}}>
              Send reminder:
            </span>
            <span className={"pulseTextBodySmallBold"} style={{gridColumn: "4"}}>
              Notify:
            </span>
            <div className={styles.divider}>
              <Divider />
            </div>
            {fields.map((field, index) => (
              <NotificationRow
                key={field.id}
                index={index}
                onRemove={() => {
                  remove(index);
                  trigger("notifications");
                }}
              />
            ))}
          </div>
          <Divider />
          <div>
            <Button variant="secondary" size="small" onClick={handleAddAnother}>
              <Icon icon={FiPlus} /> Add Another
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
};
